import React from 'react';
// import classnames from 'classnames';
import { Formik, Form } from 'formik';

import Input from 'components/UI/InputFormik';
import Button from 'components/UI/Button';

import validationSchema from './validationSchema';

import { styleInput, styleSubmit } from './styles.module.scss';

const WebinarFormElem = ({ data, onSubmit, lang }) => {
  const handleSubmit = (values) => {
    if (onSubmit) onSubmit(values);
  };

  return (
    <Formik
      initialValues={{
        first_name: '',
        last_name: '',
        email: '',
        date: new Date().toLocaleString('en-IN', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }),
      }}
      validationSchema={validationSchema(lang)}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          handleSubmit(values);
        }, 400);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form noValidate>
            <Input
              name="first_name"
              type="text"
              label={data?.webinarOnDemandFormFirstNameLabel}
              // placeholder={''}
              requiredField={true}
              className={styleInput}
            />

            <Input
              name="last_name"
              type="text"
              label={data?.webinarOnDemandFormLastNameLabel}
              // placeholder={''}
              requiredField={true}
              className={styleInput}
            />

            <Input
              name="email"
              type="email"
              label={data?.webinarOnDemandFormEmailLabel}
              // placeholder={''}
              requiredField={true}
              className={styleInput}
            />

            <Button
              type="submit"
              className={styleSubmit}
              id="webinar-on-demand-form-submit"
            >
              {data?.webinarOnDemandFormSubmitButton}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default WebinarFormElem;
